// IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
// Поиск чипса по НОМЕРУ СТРОКИ в заголовке строки таблицы: запрос «124» — совпадение со строкой, у которой там показан номер 124. Номер = индекс строки грида + 1 (+ rowIndexOffset
// секций печати), как рисует formatItem. Только ТОЧНОЕ равенство полному номеру (без префикса: «1» не цепляет 10..199). Чистые функции без Vue и DOM; хост — AttrGrid
// (gridSearchRowNum_on / _hit / _setCur, apply_CHIPS, gridSearchNav_recompute, onChipSearchNav, formatItem). Юнит tests/unit/gridSearchRowNum.test.mjs.
import { searchTerms } from './searchMatch'

// показанный номер строки r (индекс строки грида, с нуля)
export function rowNum_text(r, offset = 0) { return String(r + 1 + (Number(offset) || 0)) }   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)

// термины остановок ‹ › ({t, phrase?}) или строки: хоть один, не фраза, равен номеру
export function rowNum_hitTerms(numText, terms) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
    if (!terms || !terms.length) return false
    return terms.some(x => {
        if (x && typeof x === 'object') return !x.phrase && String(x.t ?? '') === numText
        return String(x ?? '') === numText
    })
}

// запись hide-массива apply_CHIPS (по одной на термин) — точный номер строки; выражения, фразы, отборы по условию / метрике / стилю / формату — нет
export function rowNum_hideHit(ch, numText) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
    return !!ch && ch.segment === 'CHIP-Search' && !ch._phrase && !ch._where && !ch._metric && !ch._style && !ch._format && typeof ch.title === 'string' && ch.title !== '' && ch.title === numText
}

// числовые части запроса действующих чипсов поиска (Set строк) — по ним подсвечивается номер в заголовке строки; isPhrase(chip, text) — чипс в режиме фразы (части не ищутся)
export function rowNum_chipTerms(chips, isPhrase) {   // IE 2026 10 24 / ODOO-348831 (заказ Игоря: поиск чипса по номеру строки в заголовке строки)
    const out = new Set()
    for (const c of chips || []) {
        if (!c || c.segment !== 'CHIP-Search' || (c.meta && c.meta.use === false)) continue
        const t0 = String(c.title == null ? '' : c.title).trim()
        if (!t0 || t0.startsWith('=') || t0.startsWith('style:')) continue
        if (isPhrase && isPhrase(c, t0)) continue
        for (const p of searchTerms(t0)) if (/^\d+$/.test(p)) out.add(p)
    }
    return out
}
